import { render, staticRenderFns } from "./FieldPropsModal.vue?vue&type=template&id=4fe98f9b&"
import script from "./FieldPropsModal.vue?vue&type=script&lang=js&"
export * from "./FieldPropsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports